import { Video } from "@crystallize/reactjs-components";
import { Paragraph } from "~/use-cases/contracts/Paragraph";
import { ImageSlider } from "../image-gallery";
import { RichTextRenderer } from "~/ui/components/rich-text-renderer";

export const ParagraphCollection: React.FC<{ paragraphs: Paragraph[] }> = ({
  paragraphs,
}) => {
  if (paragraphs.length === 0) {
    return null;
  }

  return (
    <div className="frntr-paragraphs mb-12">
      {paragraphs.map((paragraph, index) => (
        <div key={index}>
          <div className="pt-5 frntr-paragraph w-auto">
            {paragraph.title && (
              <h2 className="font-semibold mt-4 text-2xl lg:text-3xl">
                {paragraph.title}
              </h2>
            )}
            <div className="frntr-content-transformer">
              <RichTextRenderer json={paragraph.body.json} />
            </div>
          </div>
          <ImageSlider images={paragraph?.images} />
          {paragraph.videos && paragraph.videos.length > 0 && (
            <div className="w-full img-container img-contain md:py-0">
              <Video
                {...paragraph?.videos?.[0]}
                thumbnailProps={{ sizes: "(max-width: 700px) 90vw, 700px" }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
